module.exports = __webpack_public_path__ + "img/menu-button.654b2431.svg";